const place_list_button = {
  confirm: 'Esta rama tiene',
  confirm1: 'equipos en total. ¿Quiere generar todos los códigos qr para esta rama?',
  title: 'GENERAR QRCODE',
  else: 'Esta rama no cuenta con ningún equipo. Agregue los equipos en las hojas de esta rama y luego imprima los códigos qr.'
};

export default place_list_button;
